import instagram from '../assets/instagram.svg'
import twitter from '../assets/twitter.svg'
import facebook from '../assets/facebook.svg'
import linkedin from '../assets/linkedin.svg'
export const navLinks = [
  {
    id: "/",
    title: "Home",
  },
  {
    id: "/about",
    title: "About Us",
  },
  {
    id: "/solutions",
    title: "Solutions",
  },
  {
    id: "/partners",
    title: "Partners",
  },
  {
    id: "/contact",
    title: "Contact Us",
  },
];



export const footerLinks = [
  {
    title: "Head Office Jakarta",
    links: [
      {
        id : 1,
        name: "Jl. Pintu Air Raya",
        target:"_blank",
        link: "",
      },
      {
        id : 2,
        name: " No. 2F Jakarta 10710, Indonesia",
        target:"_blank",
        link: "",
      },
      {
        id : 3,
        name: "Jakarta 10220, Indonesia",
        target:"_blank",
        link: "",
      },
      {
        id : 4,
        name: "+62213867575",
        target:"_blank",
        link: "https://api.whatsapp.com/send?phone=6285290003973&text=Hi%20Mastersystem..%20Saya%20ingin%20tahu%20informasi%20mengenai%20produk%20IBM%20Mastersystem.%20Tolong%20respon%20chat%20saya%20ya..&source=&data=",
      }
    ],
  }
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/mastersysteminfotama/",
  },
  {
    id: "social-media-2",
    icon: twitter,
    link: "https://www.youtube.com/c/mastersysteminfotamaofficial",
  },
  {
    id: "social-media-3",
    icon: facebook,
    link: "https://www.facebook.com/checkpoint/1501092823525282/?next=https%3A%2F%2Fwww.facebook.com%2Fmastersystemict%2F",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/in/pt-mastersystem-infotama/detail/recent-activity/",
  },
];

